import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AppService } from '../../../../../services';
import { ConfigurationAreaService } from '../../../../configuration/configuration-area.service';
import { ConfigurationAcceleratorsService } from '../../configuration-accelerators.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'configuration-accelerators-accelerators-view-part',
	standalone: true,
	templateUrl: './accelerators-view.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [GridContentWidget],
})
export class ConfigurationAcceleratorsAcceleratorsViewPart {

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly areaService = inject(ConfigurationAreaService);
	private readonly pageService = inject(ConfigurationAcceleratorsService);
	public setup = getSetup(this.util, this.app);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public accelerators = computed(() => {
		const accelerators = this.areaService.configurationData()?.accelerators;
		if (!accelerators) return [];

		return accelerators.map(a => {
			const formattedData = this.util.date.formatAccMeetingSlot(a.meetingStartSlot, a.standardFourTimeZoneId, true, this.app.data().standardLocalTimezoneId)
			return {
				...a,
				meetingAcceleratorDisplayText: formattedData.acceleratorDisplayTime,
				meetingLocalDisplayText: formattedData.localDisplayTime
			};
		})
	});
}